import { obterConfiguracaoDev } from "@/lib/dev-config.functions";

let logarAuthAtivo = false;
let autoDiagnosticoAtivo = false;

export function podeLogarAuth(): boolean {
  return logarAuthAtivo;
}

export function podeExecutarAutoDiagnostico(): boolean {
  return autoDiagnosticoAtivo;
}

/** Executada uma vez em cada carregamento completo da página. */
export async function carregarConfiguracaoDev(): Promise<void> {
  try {
    const config = await obterConfiguracaoDev();
    logarAuthAtivo = config.logarAuth === true;
    autoDiagnosticoAtivo = config.autoDiagnostico === true;
    if (logarAuthAtivo) {
      console.info("[auth][config] Logs de autenticação do front-end ATIVADOS.");
    }
    if (autoDiagnosticoAtivo) {
      console.info("[auth][config] Diagnóstico automático do backend ATIVADO.");
    }
  } catch (erro) {
    logarAuthAtivo = false;
    autoDiagnosticoAtivo = false;
    console.warn("[auth][config] Não foi possível carregar config/dev.config.json.", erro);
  }
}
